export const FEATURE_RESTRICTION_UPGRADE_MODAL_SHOW =
  'FEATURE_RESTRICTION_UPGRADE_MODAL_SHOW';
export const FEATURE_RESTRICTION_UPGRADE_MODAL_HIDE =
  'FEATURE_RESTRICTION_UPGRADE_MODAL_HIDE';
